export const FormatsData: import('../../../sim/dex-species').ModdedSpeciesFormatsDataTable = {
	bulbasaur: {
		isNonstandard: "Past",
	},
	ivysaur: {
		isNonstandard: "Past",
	},
	venusaur: {
		isNonstandard: "Past",
	},
	venusaurgmax: {
		isNonstandard: "Past",
	},
	charmander: {
		isNonstandard: "Past",
	},
	charmeleon: {
		isNonstandard: "Past",
	},
	charizard: {
		isNonstandard: "Past",
	},
	charizardgmax: {
		isNonstandard: "Past",
	},
	squirtle: {
		isNonstandard: "Past",
	},
	wartortle: {
		isNonstandard: "Past",
	},
	blastoise: {
		isNonstandard: "Past",
	},
	blastoisegmax: {
		isNonstandard: "Past",
	},
	caterpie: {
		isNonstandard: "Past",
	},
	metapod: {
		isNonstandard: "Past",
	},
	butterfree: {
		isNonstandard: "Past",
	},
	butterfreegmax: {
		isNonstandard: "Past",
	},
	pikachu: {
		isNonstandard: null,
	},
	pikachuoriginal: {
		isNonstandard: "Past",
	},
	pikachuhoenn: {
		isNonstandard: "Past",
	},
	pikachusinnoh: {
		isNonstandard: "Past",
	},
	pikachuunova: {
		isNonstandard: "Past",
	},
	pikachukalos: {
		isNonstandard: "Past",
	},
	pikachualola: {
		isNonstandard: "Past",
	},
	pikachupartner: {
		isNonstandard: "Past",
	},
	pikachugmax: {
		isNonstandard: "Past",
	},
	pikachuworld: {
		isNonstandard: "Past",
	},
	raichu: {
		isNonstandard: null,
	},
	raichualola: {
		isNonstandard: "Past",
	},
	sandshrew: {
		isNonstandard: "Past",
	},
	sandshrewalola: {
		isNonstandard: "Past",
	},
	sandslash: {
		isNonstandard: "Past",
	},
	sandslashalola: {
		isNonstandard: "Past",
	},
	nidoranf: {
		isNonstandard: "Past",
	},
	nidorina: {
		isNonstandard: "Past",
	},
	nidoqueen: {
		isNonstandard: "Past",
	},
	nidoranm: {
		isNonstandard: "Past",
	},
	nidorino: {
		isNonstandard: "Past",
	},
	nidoking: {
		isNonstandard: "Past",
	},
	clefairy: {
		isNonstandard: null,
	},
	clefable: {
		isNonstandard: null,
	},
	vulpix: {
		isNonstandard: null,
	},
	vulpixalola: {
		isNonstandard: null,
	},
	ninetales: {
		isNonstandard: null,
	},
	ninetalesalola: {
		isNonstandard: null,
	},
	jigglypuff: {
		isNonstandard: "Past",
	},
	wigglytuff: {
		isNonstandard: "Past",
	},
	zubat: {
		isNonstandard: null,
	},
	golbat: {
		isNonstandard: null,
	},
	oddish: {
		isNonstandard: "Past",
	},
	gloom: {
		isNonstandard: "Past",
	},
	vileplume: {
		isNonstandard: "Past",
	},
	paras: {
		isNonstandard: null,
	},
	parasect: {
		isNonstandard: null,
	},
	diglett: {
		isNonstandard: "Past",
	},
	diglettalola: {
		isNonstandard: "Past",
	},
	dugtrio: {
		isNonstandard: "Past",
	},
	dugtrioalola: {
		isNonstandard: "Past",
	},
	meowth: {
		isNonstandard: "Past",
	},
	meowthalola: {
		isNonstandard: "Past",
	},
	meowthgalar: {
		isNonstandard: "Past",
	},
	meowthgmax: {
		isNonstandard: "Past",
	},
	persian: {
		isNonstandard: "Past",
	},
	persianalola: {
		isNonstandard: "Past",
	},
	psyduck: {
		isNonstandard: null,
	},
	golduck: {
		isNonstandard: null,
	},
	growlithe: {
		isNonstandard: "Past",
	},
	growlithehisui: {
		isNonstandard: null,
	},
	arcanine: {
		isNonstandard: "Past",
	},
	arcaninehisui: {
		isNonstandard: null,
	},
	poliwag: {
		isNonstandard: "Past",
	},
	poliwhirl: {
		isNonstandard: "Past",
	},
	poliwrath: {
		isNonstandard: "Past",
	},
	abra: {
		isNonstandard: null,
	},
	kadabra: {
		isNonstandard: null,
	},
	alakazam: {
		isNonstandard: null,
	},
	machop: {
		isNonstandard: null,
	},
	machoke: {
		isNonstandard: null,
	},
	machamp: {
		isNonstandard: null,
	},
	machampgmax: {
		isNonstandard: "Past",
	},
	tentacool: {
		isNonstandard: null,
	},
	tentacruel: {
		isNonstandard: null,
	},
	geodude: {
		isNonstandard: null,
	},
	graveler: {
		isNonstandard: null,
	},
	golem: {
		isNonstandard: null,
	},
	ponyta: {
		isNonstandard: null,
	},
	ponytagalar: {
		isNonstandard: "Past",
	},
	rapidash: {
		isNonstandard: null,
	},
	rapidashgalar: {
		isNonstandard: "Past",
	},
	slowpoke: {
		isNonstandard: "Past",
	},
	slowpokegalar: {
		isNonstandard: "Past",
	},
	slowbro: {
		isNonstandard: "Past",
	},
	slowbrogalar: {
		isNonstandard: "Past",
	},
	magnemite: {
		isNonstandard: null,
	},
	magneton: {
		isNonstandard: null,
	},
	farfetchd: {
		isNonstandard: "Past",
	},
	farfetchdgalar: {
		isNonstandard: "Past",
	},
	shellder: {
		isNonstandard: "Past",
	},
	cloyster: {
		isNonstandard: "Past",
	},
	gastly: {
		isNonstandard: null,
	},
	haunter: {
		isNonstandard: null,
	},
	gengar: {
		isNonstandard: null,
	},
	gengargmax: {
		isNonstandard: "Past",
	},
	onix: {
		isNonstandard: null,
	},
	krabby: {
		isNonstandard: "Past",
	},
	kingler: {
		isNonstandard: "Past",
	},
	kinglergmax: {
		isNonstandard: "Past",
	},
	voltorbhisui: {
		isNonstandard: null,
	},
	electrodehisui: {
		isNonstandard: null,
	},
	exeggcute: {
		isNonstandard: "Past",
	},
	exeggutor: {
		isNonstandard: "Past",
	},
	exeggutoralola: {
		isNonstandard: "Past",
	},
	cubone: {
		isNonstandard: "Past",
	},
	marowak: {
		isNonstandard: "Past",
	},
	marowakalola: {
		isNonstandard: "Past",
	},
	hitmonlee: {
		isNonstandard: "Past",
	},
	hitmonchan: {
		isNonstandard: "Past",
	},
	lickitung: {
		isNonstandard: null,
	},
	koffing: {
		isNonstandard: "Past",
	},
	weezing: {
		isNonstandard: "Past",
	},
	weezinggalar: {
		isNonstandard: "Past",
	},
	rhyhorn: {
		isNonstandard: null,
	},
	rhydon: {
		isNonstandard: null,
	},
	chansey: {
		isNonstandard: null,
	},
	tangela: {
		isNonstandard: null,
	},
	kangaskhan: {
		isNonstandard: "Past",
	},
	horsea: {
		isNonstandard: "Past",
	},
	seadra: {
		isNonstandard: "Past",
	},
	goldeen: {
		isNonstandard: "Past",
	},
	seaking: {
		isNonstandard: "Past",
	},
	staryu: {
		isNonstandard: "Past",
	},
	starmie: {
		isNonstandard: "Past",
	},
	mrmime: {
		isNonstandard: null,
	},
	mrmimegalar: {
		isNonstandard: "Past",
	},
	scyther: {
		isNonstandard: null,
	},
	jynx: {
		isNonstandard: "Past",
	},
	electabuzz: {
		isNonstandard: null,
	},
	magmar: {
		isNonstandard: null,
	},
	pinsir: {
		isNonstandard: "Past",
	},
	tauros: {
		isNonstandard: "Past",
	},
	magikarp: {
		isNonstandard: null,
	},
	gyarados: {
		isNonstandard: null,
	},
	lapras: {
		isNonstandard: "Past",
	},
	laprasgmax: {
		isNonstandard: "Past",
	},
	ditto: {
		isNonstandard: "Past",
	},
	eevee: {
		isNonstandard: null,
	},
	eeveegmax: {
		isNonstandard: "Past",
	},
	vaporeon: {
		isNonstandard: null,
	},
	jolteon: {
		isNonstandard: null,
	},
	flareon: {
		isNonstandard: null,
	},
	porygon: {
		isNonstandard: null,
	},
	omanyte: {
		isNonstandard: "Past",
	},
	omastar: {
		isNonstandard: "Past",
	},
	kabuto: {
		isNonstandard: "Past",
	},
	kabutops: {
		isNonstandard: "Past",
	},
	aerodactyl: {
		isNonstandard: "Past",
	},
	snorlax: {
		isNonstandard: null,
	},
	snorlaxgmax: {
		isNonstandard: "Past",
	},
	articuno: {
		isNonstandard: "Past",
	},
	articunogalar: {
		isNonstandard: "Past",
	},
	zapdos: {
		isNonstandard: "Past",
	},
	zapdosgalar: {
		isNonstandard: "Past",
	},
	moltres: {
		isNonstandard: "Past",
	},
	moltresgalar: {
		isNonstandard: "Past",
	},
	dratini: {
		isNonstandard: "Past",
	},
	dragonair: {
		isNonstandard: "Past",
	},
	dragonite: {
		isNonstandard: "Past",
	},
	mewtwo: {
		isNonstandard: "Past",
	},
	mew: {
		isNonstandard: "Past",
	},
	cyndaquil: {
		isNonstandard: null,
	},
	quilava: {
		isNonstandard: null,
	},
	typhlosionhisui: {
		isNonstandard: null,
	},
	hoothoot: {
		isNonstandard: "Past",
	},
	noctowl: {
		isNonstandard: "Past",
	},
	crobat: {
		isNonstandard: null,
	},
	chinchou: {
		isNonstandard: "Past",
	},
	lanturn: {
		isNonstandard: "Past",
	},
	pichu: {
		isNonstandard: null,
	},
	cleffa: {
		isNonstandard: null,
	},
	igglybuff: {
		isNonstandard: "Past",
	},
	togepi: {
		isNonstandard: null,
	},
	togetic: {
		isNonstandard: null,
	},
	natu: {
		isNonstandard: "Past",
	},
	xatu: {
		isNonstandard: "Past",
	},
	bellossom: {
		isNonstandard: "Past",
	},
	marill: {
		isNonstandard: "Past",
	},
	azumarill: {
		isNonstandard: "Past",
	},
	sudowoodo: {
		isNonstandard: null,
	},
	politoed: {
		isNonstandard: "Past",
	},
	aipom: {
		isNonstandard: null,
	},
	yanma: {
		isNonstandard: null,
	},
	wooper: {
		isNonstandard: "Past",
	},
	quagsire: {
		isNonstandard: "Past",
	},
	espeon: {
		isNonstandard: null,
	},
	umbreon: {
		isNonstandard: null,
	},
	murkrow: {
		isNonstandard: null,
	},
	slowking: {
		isNonstandard: "Past",
	},
	slowkinggalar: {
		isNonstandard: "Past",
	},
	misdreavus: {
		isNonstandard: null,
	},
	unown: {
		isNonstandard: null,
	},
	wobbuffet: {
		isNonstandard: "Past",
	},
	dunsparce: {
		isNonstandard: "Past",
	},
	gligar: {
		isNonstandard: null,
	},
	steelix: {
		isNonstandard: null,
	},
	qwilfish: {
		isNonstandard: "Past",
	},
	qwilfishhisui: {
		isNonstandard: null,
	},
	scizor: {
		isNonstandard: null,
	},
	shuckle: {
		isNonstandard: "Past",
	},
	heracross: {
		isNonstandard: null,
	},
	sneasel: {
		isNonstandard: null,
	},
	sneaselhisui: {
		isNonstandard: null,
	},
	teddiursa: {
		isNonstandard: null,
	},
	ursaring: {
		isNonstandard: null,
	},
	swinub: {
		isNonstandard: null,
	},
	piloswine: {
		isNonstandard: null,
	},
	corsola: {
		isNonstandard: "Past",
	},
	corsolagalar: {
		isNonstandard: "Past",
	},
	remoraid: {
		isNonstandard: null,
	},
	octillery: {
		isNonstandard: null,
	},
	delibird: {
		isNonstandard: "Past",
	},
	mantine: {
		isNonstandard: null,
	},
	skarmory: {
		isNonstandard: "Past",
	},
	kingdra: {
		isNonstandard: "Past",
	},
	porygon2: {
		isNonstandard: null,
	},
	stantler: {
		isNonstandard: null,
	},
	tyrogue: {
		isNonstandard: "Past",
	},
	hitmontop: {
		isNonstandard: "Past",
	},
	smoochum: {
		isNonstandard: "Past",
	},
	elekid: {
		isNonstandard: null,
	},
	magby: {
		isNonstandard: null,
	},
	miltank: {
		isNonstandard: "Past",
	},
	blissey: {
		isNonstandard: null,
	},
	raikou: {
		isNonstandard: "Past",
	},
	entei: {
		isNonstandard: "Past",
	},
	suicune: {
		isNonstandard: "Past",
	},
	larvitar: {
		isNonstandard: "Past",
	},
	pupitar: {
		isNonstandard: "Past",
	},
	tyranitar: {
		isNonstandard: "Past",
	},
	lugia: {
		isNonstandard: "Past",
	},
	hooh: {
		isNonstandard: "Past",
	},
	celebi: {
		isNonstandard: "Past",
	},
	treecko: {
		isNonstandard: "Past",
	},
	grovyle: {
		isNonstandard: "Past",
	},
	sceptile: {
		isNonstandard: "Past",
	},
	torchic: {
		isNonstandard: "Past",
	},
	combusken: {
		isNonstandard: "Past",
	},
	blaziken: {
		isNonstandard: "Past",
	},
	mudkip: {
		isNonstandard: "Past",
	},
	marshtomp: {
		isNonstandard: "Past",
	},
	swampert: {
		isNonstandard: "Past",
	},
	zigzagoon: {
		isNonstandard: "Past",
	},
	zigzagoongalar: {
		isNonstandard: "Past",
	},
	linoone: {
		isNonstandard: "Past",
	},
	linoonegalar: {
		isNonstandard: "Past",
	},
	wurmple: {
		isNonstandard: null,
	},
	silcoon: {
		isNonstandard: null,
	},
	beautifly: {
		isNonstandard: null,
	},
	cascoon: {
		isNonstandard: null,
	},
	dustox: {
		isNonstandard: null,
	},
	lotad: {
		isNonstandard: "Past",
	},
	lombre: {
		isNonstandard: "Past",
	},
	ludicolo: {
		isNonstandard: "Past",
	},
	seedot: {
		isNonstandard: "Past",
	},
	nuzleaf: {
		isNonstandard: "Past",
	},
	shiftry: {
		isNonstandard: "Past",
	},
	wingull: {
		isNonstandard: "Past",
	},
	pelipper: {
		isNonstandard: "Past",
	},
	ralts: {
		isNonstandard: null,
	},
	kirlia: {
		isNonstandard: null,
	},
	gardevoir: {
		isNonstandard: null,
	},
	nincada: {
		isNonstandard: "Past",
	},
	ninjask: {
		isNonstandard: "Past",
	},
	shedinja: {
		isNonstandard: "Past",
	},
	whismur: {
		isNonstandard: "Past",
	},
	loudred: {
		isNonstandard: "Past",
	},
	exploud: {
		isNonstandard: "Past",
	},
	azurill: {
		isNonstandard: "Past",
	},
	nosepass: {
		isNonstandard: null,
	},
	sableye: {
		isNonstandard: "Past",
	},
	mawile: {
		isNonstandard: "Past",
	},
	aron: {
		isNonstandard: "Past",
	},
	lairon: {
		isNonstandard: "Past",
	},
	aggron: {
		isNonstandard: "Past",
	},
	electrike: {
		isNonstandard: "Past",
	},
	manectric: {
		isNonstandard: "Past",
	},
	roselia: {
		isNonstandard: null,
	},
	carvanha: {
		isNonstandard: "Past",
	},
	sharpedo: {
		isNonstandard: "Past",
	},
	wailmer: {
		isNonstandard: "Past",
	},
	wailord: {
		isNonstandard: "Past",
	},
	torkoal: {
		isNonstandard: "Past",
	},
	trapinch: {
		isNonstandard: "Past",
	},
	vibrava: {
		isNonstandard: "Past",
	},
	flygon: {
		isNonstandard: "Past",
	},
	swablu: {
		isNonstandard: "Past",
	},
	altaria: {
		isNonstandard: "Past",
	},
	lunatone: {
		isNonstandard: "Past",
	},
	solrock: {
		isNonstandard: "Past",
	},
	barboach: {
		isNonstandard: null,
	},
	whiscash: {
		isNonstandard: null,
	},
	corphish: {
		isNonstandard: "Past",
	},
	crawdaunt: {
		isNonstandard: "Past",
	},
	baltoy: {
		isNonstandard: "Past",
	},
	claydol: {
		isNonstandard: "Past",
	},
	lileep: {
		isNonstandard: "Past",
	},
	cradily: {
		isNonstandard: "Past",
	},
	anorith: {
		isNonstandard: "Past",
	},
	armaldo: {
		isNonstandard: "Past",
	},
	feebas: {
		isNonstandard: "Past",
	},
	milotic: {
		isNonstandard: "Past",
	},
	duskull: {
		isNonstandard: null,
	},
	dusclops: {
		isNonstandard: null,
	},
	chimecho: {
		isNonstandard: null,
	},
	absol: {
		isNonstandard: "Past",
	},
	wynaut: {
		isNonstandard: "Past",
	},
	snorunt: {
		isNonstandard: null,
	},
	glalie: {
		isNonstandard: null,
	},
	spheal: {
		isNonstandard: null,
	},
	sealeo: {
		isNonstandard: null,
	},
	walrein: {
		isNonstandard: null,
	},
	relicanth: {
		isNonstandard: "Past",
	},
	bagon: {
		isNonstandard: "Past",
	},
	shelgon: {
		isNonstandard: "Past",
	},
	salamence: {
		isNonstandard: "Past",
	},
	beldum: {
		isNonstandard: "Past",
	},
	metang: {
		isNonstandard: "Past",
	},
	metagross: {
		isNonstandard: "Past",
	},
	regirock: {
		isNonstandard: "Past",
	},
	regice: {
		isNonstandard: "Past",
	},
	registeel: {
		isNonstandard: "Past",
	},
	latias: {
		isNonstandard: "Past",
	},
	latios: {
		isNonstandard: "Past",
	},
	kyogre: {
		isNonstandard: "Past",
	},
	groudon: {
		isNonstandard: "Past",
	},
	rayquaza: {
		isNonstandard: "Past",
	},
	jirachi: {
		isNonstandard: "Past",
	},
	turtwig: {
		isNonstandard: null,
	},
	grotle: {
		isNonstandard: null,
	},
	torterra: {
		isNonstandard: null,
	},
	chimchar: {
		isNonstandard: null,
	},
	monferno: {
		isNonstandard: null,
	},
	infernape: {
		isNonstandard: null,
	},
	piplup: {
		isNonstandard: null,
	},
	prinplup: {
		isNonstandard: null,
	},
	empoleon: {
		isNonstandard: null,
	},
	starly: {
		isNonstandard: null,
	},
	staravia: {
		isNonstandard: null,
	},
	staraptor: {
		isNonstandard: null,
	},
	bidoof: {
		isNonstandard: null,
	},
	bibarel: {
		isNonstandard: null,
	},
	kricketot: {
		isNonstandard: null,
	},
	kricketune: {
		isNonstandard: null,
	},
	shinx: {
		isNonstandard: null,
	},
	luxio: {
		isNonstandard: null,
	},
	luxray: {
		isNonstandard: null,
	},
	budew: {
		isNonstandard: null,
	},
	roserade: {
		isNonstandard: null,
	},
	cranidos: {
		isNonstandard: null,
	},
	rampardos: {
		isNonstandard: null,
	},
	shieldon: {
		isNonstandard: null,
	},
	bastiodon: {
		isNonstandard: null,
	},
	burmy: {
		isNonstandard: null,
	},
	wormadam: {
		isNonstandard: null,
	},
	wormadamsandy: {
		isNonstandard: null,
	},
	wormadamtrash: {
		isNonstandard: null,
	},
	mothim: {
		isNonstandard: null,
	},
	combee: {
		isNonstandard: null,
	},
	vespiquen: {
		isNonstandard: null,
	},
	pachirisu: {
		isNonstandard: null,
	},
	buizel: {
		isNonstandard: null,
	},
	floatzel: {
		isNonstandard: null,
	},
	cherubi: {
		isNonstandard: null,
	},
	cherrim: {
		isNonstandard: null,
	},
	cherrimsunshine: {
		isNonstandard: null,
	},
	shellos: {
		isNonstandard: null,
	},
	gastrodon: {
		isNonstandard: null,
	},
	ambipom: {
		isNonstandard: null,
	},
	drifloon: {
		isNonstandard: null,
	},
	drifblim: {
		isNonstandard: null,
	},
	buneary: {
		isNonstandard: null,
	},
	lopunny: {
		isNonstandard: null,
	},
	mismagius: {
		isNonstandard: null,
	},
	honchkrow: {
		isNonstandard: null,
	},
	glameow: {
		isNonstandard: null,
	},
	purugly: {
		isNonstandard: null,
	},
	chingling: {
		isNonstandard: null,
	},
	stunky: {
		isNonstandard: null,
	},
	skuntank: {
		isNonstandard: null,
	},
	bronzor: {
		isNonstandard: null,
	},
	bronzong: {
		isNonstandard: null,
	},
	bonsly: {
		isNonstandard: null,
	},
	mimejr: {
		isNonstandard: null,
	},
	happiny: {
		isNonstandard: null,
	},
	chatot: {
		isNonstandard: null,
	},
	spiritomb: {
		isNonstandard: null,
	},
	gible: {
		isNonstandard: null,
	},
	gabite: {
		isNonstandard: null,
	},
	garchomp: {
		isNonstandard: null,
	},
	munchlax: {
		isNonstandard: null,
	},
	riolu: {
		isNonstandard: null,
	},
	lucario: {
		isNonstandard: null,
	},
	hippopotas: {
		isNonstandard: null,
	},
	hippowdon: {
		isNonstandard: null,
	},
	skorupi: {
		isNonstandard: null,
	},
	drapion: {
		isNonstandard: null,
	},
	croagunk: {
		isNonstandard: null,
	},
	toxicroak: {
		isNonstandard: null,
	},
	carnivine: {
		isNonstandard: null,
	},
	finneon: {
		isNonstandard: null,
	},
	lumineon: {
		isNonstandard: null,
	},
	mantyke: {
		isNonstandard: null,
	},
	snover: {
		isNonstandard: null,
	},
	abomasnow: {
		isNonstandard: null,
	},
	weavile: {
		isNonstandard: null,
	},
	magnezone: {
		isNonstandard: null,
	},
	lickilicky: {
		isNonstandard: null,
	},
	rhyperior: {
		isNonstandard: null,
	},
	tangrowth: {
		isNonstandard: null,
	},
	electivire: {
		isNonstandard: null,
	},
	magmortar: {
		isNonstandard: null,
	},
	togekiss: {
		isNonstandard: null,
	},
	yanmega: {
		isNonstandard: null,
	},
	leafeon: {
		isNonstandard: null,
	},
	glaceon: {
		isNonstandard: null,
	},
	gliscor: {
		isNonstandard: null,
	},
	mamoswine: {
		isNonstandard: null,
	},
	porygonz: {
		isNonstandard: null,
	},
	gallade: {
		isNonstandard: null,
	},
	probopass: {
		isNonstandard: null,
	},
	dusknoir: {
		isNonstandard: null,
	},
	froslass: {
		isNonstandard: null,
	},
	rotom: {
		isNonstandard: null,
	},
	rotomheat: {
		isNonstandard: null,
	},
	rotomwash: {
		isNonstandard: null,
	},
	rotomfrost: {
		isNonstandard: null,
	},
	rotomfan: {
		isNonstandard: null,
	},
	rotommow: {
		isNonstandard: null,
	},
	uxie: {
		isNonstandard: null,
	},
	mesprit: {
		isNonstandard: null,
	},
	azelf: {
		isNonstandard: null,
	},
	dialga: {
		isNonstandard: null,
	},
	dialgaorigin: {
		isNonstandard: null,
	},
	palkia: {
		isNonstandard: null,
	},
	palkiaorigin: {
		isNonstandard: null,
	},
	heatran: {
		isNonstandard: null,
	},
	regigigas: {
		isNonstandard: null,
	},
	giratina: {
		isNonstandard: null,
	},
	giratinaorigin: {
		isNonstandard: null,
	},
	cresselia: {
		isNonstandard: null,
	},
	phione: {
		isNonstandard: null,
	},
	manaphy: {
		isNonstandard: null,
	},
	darkrai: {
		isNonstandard: null,
	},
	shaymin: {
		isNonstandard: null,
	},
	shayminsky: {
		isNonstandard: null,
	},
	arceus: {
		isNonstandard: null,
	},
	arceusbug: {
		isNonstandard: null,
	},
	arceusdark: {
		isNonstandard: null,
	},
	arceusdragon: {
		isNonstandard: null,
	},
	arceuselectric: {
		isNonstandard: null,
	},
	arceusfairy: {
		isNonstandard: null,
	},
	arceusfighting: {
		isNonstandard: null,
	},
	arceusfire: {
		isNonstandard: null,
	},
	arceusflying: {
		isNonstandard: null,
	},
	arceusghost: {
		isNonstandard: null,
	},
	arceusgrass: {
		isNonstandard: null,
	},
	arceusground: {
		isNonstandard: null,
	},
	arceusice: {
		isNonstandard: null,
	},
	arceuspoison: {
		isNonstandard: null,
	},
	arceuspsychic: {
		isNonstandard: null,
	},
	arceusrock: {
		isNonstandard: null,
	},
	arceussteel: {
		isNonstandard: null,
	},
	arceuswater: {
		isNonstandard: null,
	},
	victini: {
		isNonstandard: "Past",
	},
	oshawott: {
		isNonstandard: null,
	},
	dewott: {
		isNonstandard: null,
	},
	samurotthisui: {
		isNonstandard: null,
	},
	lillipup: {
		isNonstandard: "Past",
	},
	herdier: {
		isNonstandard: "Past",
	},
	stoutland: {
		isNonstandard: "Past",
	},
	purrloin: {
		isNonstandard: "Past",
	},
	liepard: {
		isNonstandard: "Past",
	},
	munna: {
		isNonstandard: "Past",
	},
	musharna: {
		isNonstandard: "Past",
	},
	pidove: {
		isNonstandard: "Past",
	},
	tranquill: {
		isNonstandard: "Past",
	},
	unfezant: {
		isNonstandard: "Past",
	},
	roggenrola: {
		isNonstandard: "Past",
	},
	boldore: {
		isNonstandard: "Past",
	},
	gigalith: {
		isNonstandard: "Past",
	},
	woobat: {
		isNonstandard: "Past",
	},
	swoobat: {
		isNonstandard: "Past",
	},
	drilbur: {
		isNonstandard: "Past",
	},
	excadrill: {
		isNonstandard: "Past",
	},
	audino: {
		isNonstandard: "Past",
	},
	timburr: {
		isNonstandard: "Past",
	},
	gurdurr: {
		isNonstandard: "Past",
	},
	conkeldurr: {
		isNonstandard: "Past",
	},
	tympole: {
		isNonstandard: "Past",
	},
	palpitoad: {
		isNonstandard: "Past",
	},
	seismitoad: {
		isNonstandard: "Past",
	},
	throh: {
		isNonstandard: "Past",
	},
	sawk: {
		isNonstandard: "Past",
	},
	venipede: {
		isNonstandard: "Past",
	},
	whirlipede: {
		isNonstandard: "Past",
	},
	scolipede: {
		isNonstandard: "Past",
	},
	cottonee: {
		isNonstandard: "Past",
	},
	whimsicott: {
		isNonstandard: "Past",
	},
	petilil: {
		isNonstandard: null,
	},
	lilligant: {
		isNonstandard: "Past",
	},
	lilliganthisui: {
		isNonstandard: null,
	},
	basculin: {
		isNonstandard: "Past",
	},
	basculinbluestriped: {
		isNonstandard: "Past",
	},
	basculinwhitestriped: {
		isNonstandard: null,
	},
	sandile: {
		isNonstandard: "Past",
	},
	krokorok: {
		isNonstandard: "Past",
	},
	krookodile: {
		isNonstandard: "Past",
	},
	darumaka: {
		isNonstandard: "Past",
	},
	darumakagalar: {
		isNonstandard: "Past",
	},
	darmanitan: {
		isNonstandard: "Past",
	},
	darmanitanzen: {
		isNonstandard: "Past",
	},
	darmanitangalar: {
		isNonstandard: "Past",
	},
	darmanitangalarzen: {
		isNonstandard: "Past",
	},
	maractus: {
		isNonstandard: "Past",
	},
	dwebble: {
		isNonstandard: "Past",
	},
	crustle: {
		isNonstandard: "Past",
	},
	scraggy: {
		isNonstandard: "Past",
	},
	scrafty: {
		isNonstandard: "Past",
	},
	sigilyph: {
		isNonstandard: "Past",
	},
	yamask: {
		isNonstandard: "Past",
	},
	yamaskgalar: {
		isNonstandard: "Past",
	},
	cofagrigus: {
		isNonstandard: "Past",
	},
	tirtouga: {
		isNonstandard: "Past",
	},
	carracosta: {
		isNonstandard: "Past",
	},
	archen: {
		isNonstandard: "Past",
	},
	archeops: {
		isNonstandard: "Past",
	},
	trubbish: {
		isNonstandard: "Past",
	},
	garbodor: {
		isNonstandard: "Past",
	},
	garbodorgmax: {
		isNonstandard: "Past",
	},
	zorua: {
		isNonstandard: "Past",
	},
	zoruahisui: {
		isNonstandard: null,
	},
	zoroark: {
		isNonstandard: "Past",
	},
	zoroarkhisui: {
		isNonstandard: null,
	},
	minccino: {
		isNonstandard: "Past",
	},
	cinccino: {
		isNonstandard: "Past",
	},
	gothita: {
		isNonstandard: "Past",
	},
	gothorita: {
		isNonstandard: "Past",
	},
	gothitelle: {
		isNonstandard: "Past",
	},
	solosis: {
		isNonstandard: "Past",
	},
	duosion: {
		isNonstandard: "Past",
	},
	reuniclus: {
		isNonstandard: "Past",
	},
	vanillite: {
		isNonstandard: "Past",
	},
	vanillish: {
		isNonstandard: "Past",
	},
	vanilluxe: {
		isNonstandard: "Past",
	},
	emolga: {
		isNonstandard: "Past",
	},
	karrablast: {
		isNonstandard: "Past",
	},
	escavalier: {
		isNonstandard: "Past",
	},
	foongus: {
		isNonstandard: "Past",
	},
	amoonguss: {
		isNonstandard: "Past",
	},
	frillish: {
		isNonstandard: "Past",
	},
	jellicent: {
		isNonstandard: "Past",
	},
	joltik: {
		isNonstandard: "Past",
	},
	galvantula: {
		isNonstandard: "Past",
	},
	ferroseed: {
		isNonstandard: "Past",
	},
	ferrothorn: {
		isNonstandard: "Past",
	},
	klink: {
		isNonstandard: "Past",
	},
	klang: {
		isNonstandard: "Past",
	},
	klinklang: {
		isNonstandard: "Past",
	},
	elgyem: {
		isNonstandard: "Past",
	},
	beheeyem: {
		isNonstandard: "Past",
	},
	litwick: {
		isNonstandard: "Past",
	},
	lampent: {
		isNonstandard: "Past",
	},
	chandelure: {
		isNonstandard: "Past",
	},
	axew: {
		isNonstandard: "Past",
	},
	fraxure: {
		isNonstandard: "Past",
	},
	haxorus: {
		isNonstandard: "Past",
	},
	cubchoo: {
		isNonstandard: "Past",
	},
	beartic: {
		isNonstandard: "Past",
	},
	cryogonal: {
		isNonstandard: "Past",
	},
	shelmet: {
		isNonstandard: "Past",
	},
	accelgor: {
		isNonstandard: "Past",
	},
	stunfisk: {
		isNonstandard: "Past",
	},
	stunfiskgalar: {
		isNonstandard: "Past",
	},
	mienfoo: {
		isNonstandard: "Past",
	},
	mienshao: {
		isNonstandard: "Past",
	},
	druddigon: {
		isNonstandard: "Past",
	},
	golett: {
		isNonstandard: "Past",
	},
	golurk: {
		isNonstandard: "Past",
	},
	pawniard: {
		isNonstandard: "Past",
	},
	bisharp: {
		isNonstandard: "Past",
	},
	bouffalant: {
		isNonstandard: "Past",
	},
	rufflet: {
		isNonstandard: null,
	},
	braviary: {
		isNonstandard: "Past",
	},
	braviaryhisui: {
		isNonstandard: null,
	},
	vullaby: {
		isNonstandard: "Past",
	},
	mandibuzz: {
		isNonstandard: "Past",
	},
	heatmor: {
		isNonstandard: "Past",
	},
	durant: {
		isNonstandard: "Past",
	},
	deino: {
		isNonstandard: "Past",
	},
	zweilous: {
		isNonstandard: "Past",
	},
	hydreigon: {
		isNonstandard: "Past",
	},
	larvesta: {
		isNonstandard: "Past",
	},
	volcarona: {
		isNonstandard: "Past",
	},
	cobalion: {
		isNonstandard: "Past",
	},
	terrakion: {
		isNonstandard: "Past",
	},
	virizion: {
		isNonstandard: "Past",
	},
	tornadus: {
		isNonstandard: null,
	},
	tornadustherian: {
		isNonstandard: null,
	},
	thundurus: {
		isNonstandard: null,
	},
	thundurustherian: {
		isNonstandard: null,
	},
	reshiram: {
		isNonstandard: "Past",
	},
	zekrom: {
		isNonstandard: "Past",
	},
	landorus: {
		isNonstandard: null,
	},
	landorustherian: {
		isNonstandard: null,
	},
	kyurem: {
		isNonstandard: "Past",
	},
	kyuremblack: {
		isNonstandard: "Past",
	},
	kyuremwhite: {
		isNonstandard: "Past",
	},
	keldeo: {
		isNonstandard: "Past",
	},
	keldeoresolute: {
		isNonstandard: "Past",
	},
	genesect: {
		isNonstandard: "Past",
	},
	genesectdouse: {
		isNonstandard: "Past",
	},
	genesectshock: {
		isNonstandard: "Past",
	},
	genesectburn: {
		isNonstandard: "Past",
	},
	genesectchill: {
		isNonstandard: "Past",
	},
	bunnelby: {
		isNonstandard: "Past",
	},
	diggersby: {
		isNonstandard: "Past",
	},
	fletchling: {
		isNonstandard: "Past",
	},
	fletchinder: {
		isNonstandard: "Past",
	},
	talonflame: {
		isNonstandard: "Past",
	},
	pancham: {
		isNonstandard: "Past",
	},
	pangoro: {
		isNonstandard: "Past",
	},
	espurr: {
		isNonstandard: "Past",
	},
	meowstic: {
		isNonstandard: "Past",
	},
	meowsticf: {
		isNonstandard: "Past",
	},
	honedge: {
		isNonstandard: "Past",
	},
	doublade: {
		isNonstandard: "Past",
	},
	aegislash: {
		isNonstandard: "Past",
	},
	aegislashblade: {
		isNonstandard: "Past",
	},
	spritzee: {
		isNonstandard: "Past",
	},
	aromatisse: {
		isNonstandard: "Past",
	},
	swirlix: {
		isNonstandard: "Past",
	},
	slurpuff: {
		isNonstandard: "Past",
	},
	inkay: {
		isNonstandard: "Past",
	},
	malamar: {
		isNonstandard: "Past",
	},
	binacle: {
		isNonstandard: "Past",
	},
	barbaracle: {
		isNonstandard: "Past",
	},
	skrelp: {
		isNonstandard: "Past",
	},
	dragalge: {
		isNonstandard: "Past",
	},
	clauncher: {
		isNonstandard: "Past",
	},
	clawitzer: {
		isNonstandard: "Past",
	},
	helioptile: {
		isNonstandard: "Past",
	},
	heliolisk: {
		isNonstandard: "Past",
	},
	tyrunt: {
		isNonstandard: "Past",
	},
	tyrantrum: {
		isNonstandard: "Past",
	},
	amaura: {
		isNonstandard: "Past",
	},
	aurorus: {
		isNonstandard: "Past",
	},
	sylveon: {
		isNonstandard: null,
	},
	hawlucha: {
		isNonstandard: "Past",
	},
	dedenne: {
		isNonstandard: "Past",
	},
	carbink: {
		isNonstandard: "Past",
	},
	goomy: {
		isNonstandard: null,
	},
	sliggoo: {
		isNonstandard: "Past",
	},
	sliggoohisui: {
		isNonstandard: null,
	},
	goodra: {
		isNonstandard: "Past",
	},
	goodrahisui: {
		isNonstandard: null,
	},
	klefki: {
		isNonstandard: "Past",
	},
	phantump: {
		isNonstandard: "Past",
	},
	trevenant: {
		isNonstandard: "Past",
	},
	pumpkaboo: {
		isNonstandard: "Past",
	},
	pumpkaboosmall: {
		isNonstandard: "Past",
	},
	pumpkaboolarge: {
		isNonstandard: "Past",
	},
	pumpkaboosuper: {
		isNonstandard: "Past",
	},
	gourgeist: {
		isNonstandard: "Past",
	},
	gourgeistsmall: {
		isNonstandard: "Past",
	},
	gourgeistlarge: {
		isNonstandard: "Past",
	},
	gourgeistsuper: {
		isNonstandard: "Past",
	},
	bergmite: {
		isNonstandard: null,
	},
	avalugg: {
		isNonstandard: "Past",
	},
	avalugghisui: {
		isNonstandard: null,
	},
	noibat: {
		isNonstandard: "Past",
	},
	noivern: {
		isNonstandard: "Past",
	},
	xerneas: {
		isNonstandard: "Past",
	},
	yveltal: {
		isNonstandard: "Past",
	},
	zygarde: {
		isNonstandard: "Past",
	},
	zygarde10: {
		isNonstandard: "Past",
	},
	zygardecomplete: {
		isNonstandard: "Past",
	},
	diancie: {
		isNonstandard: "Past",
	},
	volcanion: {
		isNonstandard: "Past",
	},
	rowlet: {
		isNonstandard: null,
	},
	dartrix: {
		isNonstandard: null,
	},
	decidueye: {
		isNonstandard: "Past",
	},
	decidueyehisui: {
		isNonstandard: null,
	},
	litten: {
		isNonstandard: "Past",
	},
	torracat: {
		isNonstandard: "Past",
	},
	incineroar: {
		isNonstandard: "Past",
	},
	popplio: {
		isNonstandard: "Past",
	},
	brionne: {
		isNonstandard: "Past",
	},
	primarina: {
		isNonstandard: "Past",
	},
	grubbin: {
		isNonstandard: "Past",
	},
	charjabug: {
		isNonstandard: "Past",
	},
	vikavolt: {
		isNonstandard: "Past",
	},
	cutiefly: {
		isNonstandard: "Past",
	},
	ribombee: {
		isNonstandard: "Past",
	},
	rockruff: {
		isNonstandard: "Past",
	},
	rockruffdusk: {
		isNonstandard: "Past",
	},
	lycanroc: {
		isNonstandard: "Past",
	},
	lycanrocmidnight: {
		isNonstandard: "Past",
	},
	lycanrocdusk: {
		isNonstandard: "Past",
	},
	wishiwashi: {
		isNonstandard: "Past",
	},
	wishiwashischool: {
		isNonstandard: "Past",
	},
	mareanie: {
		isNonstandard: "Past",
	},
	toxapex: {
		isNonstandard: "Past",
	},
	mudbray: {
		isNonstandard: "Past",
	},
	mudsdale: {
		isNonstandard: "Past",
	},
	dewpider: {
		isNonstandard: "Past",
	},
	araquanid: {
		isNonstandard: "Past",
	},
	fomantis: {
		isNonstandard: "Past",
	},
	lurantis: {
		isNonstandard: "Past",
	},
	morelull: {
		isNonstandard: "Past",
	},
	shiinotic: {
		isNonstandard: "Past",
	},
	salandit: {
		isNonstandard: "Past",
	},
	salazzle: {
		isNonstandard: "Past",
	},
	stufful: {
		isNonstandard: "Past",
	},
	bewear: {
		isNonstandard: "Past",
	},
	bounsweet: {
		isNonstandard: "Past",
	},
	steenee: {
		isNonstandard: "Past",
	},
	tsareena: {
		isNonstandard: "Past",
	},
	comfey: {
		isNonstandard: "Past",
	},
	oranguru: {
		isNonstandard: "Past",
	},
	passimian: {
		isNonstandard: "Past",
	},
	wimpod: {
		isNonstandard: "Past",
	},
	golisopod: {
		isNonstandard: "Past",
	},
	sandygast: {
		isNonstandard: "Past",
	},
	palossand: {
		isNonstandard: "Past",
	},
	pyukumuku: {
		isNonstandard: "Past",
	},
	typenull: {
		isNonstandard: "Past",
	},
	silvally: {
		isNonstandard: "Past",
	},
	silvallybug: {
		isNonstandard: "Past",
	},
	silvallydark: {
		isNonstandard: "Past",
	},
	silvallydragon: {
		isNonstandard: "Past",
	},
	silvallyelectric: {
		isNonstandard: "Past",
	},
	silvallyfairy: {
		isNonstandard: "Past",
	},
	silvallyfighting: {
		isNonstandard: "Past",
	},
	silvallyfire: {
		isNonstandard: "Past",
	},
	silvallyflying: {
		isNonstandard: "Past",
	},
	silvallyghost: {
		isNonstandard: "Past",
	},
	silvallygrass: {
		isNonstandard: "Past",
	},
	silvallyground: {
		isNonstandard: "Past",
	},
	silvallyice: {
		isNonstandard: "Past",
	},
	silvallypoison: {
		isNonstandard: "Past",
	},
	silvallypsychic: {
		isNonstandard: "Past",
	},
	silvallyrock: {
		isNonstandard: "Past",
	},
	silvallysteel: {
		isNonstandard: "Past",
	},
	silvallywater: {
		isNonstandard: "Past",
	},
	turtonator: {
		isNonstandard: "Past",
	},
	togedemaru: {
		isNonstandard: "Past",
	},
	mimikyu: {
		isNonstandard: "Past",
	},
	mimikyubusted: {
		isNonstandard: "Past",
	},
	drampa: {
		isNonstandard: "Past",
	},
	dhelmise: {
		isNonstandard: "Past",
	},
	jangmoo: {
		isNonstandard: "Past",
	},
	hakamoo: {
		isNonstandard: "Past",
	},
	kommoo: {
		isNonstandard: "Past",
	},
	tapukoko: {
		isNonstandard: "Past",
	},
	tapulele: {
		isNonstandard: "Past",
	},
	tapubulu: {
		isNonstandard: "Past",
	},
	tapufini: {
		isNonstandard: "Past",
	},
	cosmog: {
		isNonstandard: "Past",
	},
	cosmoem: {
		isNonstandard: "Past",
	},
	solgaleo: {
		isNonstandard: "Past",
	},
	lunala: {
		isNonstandard: "Past",
	},
	nihilego: {
		isNonstandard: "Past",
	},
	buzzwole: {
		isNonstandard: "Past",
	},
	pheromosa: {
		isNonstandard: "Past",
	},
	xurkitree: {
		isNonstandard: "Past",
	},
	celesteela: {
		isNonstandard: "Past",
	},
	kartana: {
		isNonstandard: "Past",
	},
	guzzlord: {
		isNonstandard: "Past",
	},
	necrozma: {
		isNonstandard: "Past",
	},
	necrozmaduskmane: {
		isNonstandard: "Past",
	},
	necrozmadawnwings: {
		isNonstandard: "Past",
	},
	magearna: {
		isNonstandard: "Past",
	},
	magearnaoriginal: {
		isNonstandard: "Past",
	},
	marshadow: {
		isNonstandard: "Past",
	},
	poipole: {
		isNonstandard: "Past",
	},
	naganadel: {
		isNonstandard: "Past",
	},
	stakataka: {
		isNonstandard: "Past",
	},
	blacephalon: {
		isNonstandard: "Past",
	},
	zeraora: {
		isNonstandard: "Past",
	},
	meltan: {
		isNonstandard: "Past",
	},
	melmetal: {
		isNonstandard: "Past",
	},
	melmetalgmax: {
		isNonstandard: "Past",
	},
	grookey: {
		isNonstandard: "Past",
	},
	thwackey: {
		isNonstandard: "Past",
	},
	rillaboom: {
		isNonstandard: "Past",
	},
	rillaboomgmax: {
		isNonstandard: "Past",
	},
	scorbunny: {
		isNonstandard: "Past",
	},
	raboot: {
		isNonstandard: "Past",
	},
	cinderace: {
		isNonstandard: "Past",
	},
	cinderacegmax: {
		isNonstandard: "Past",
	},
	sobble: {
		isNonstandard: "Past",
	},
	drizzile: {
		isNonstandard: "Past",
	},
	inteleon: {
		isNonstandard: "Past",
	},
	inteleongmax: {
		isNonstandard: "Past",
	},
	skwovet: {
		isNonstandard: "Past",
	},
	greedent: {
		isNonstandard: "Past",
	},
	rookidee: {
		isNonstandard: "Past",
	},
	corvisquire: {
		isNonstandard: "Past",
	},
	corviknight: {
		isNonstandard: "Past",
	},
	corviknightgmax: {
		isNonstandard: "Past",
	},
	blipbug: {
		isNonstandard: "Past",
	},
	dottler: {
		isNonstandard: "Past",
	},
	orbeetle: {
		isNonstandard: "Past",
	},
	orbeetlegmax: {
		isNonstandard: "Past",
	},
	nickit: {
		isNonstandard: "Past",
	},
	thievul: {
		isNonstandard: "Past",
	},
	gossifleur: {
		isNonstandard: "Past",
	},
	eldegoss: {
		isNonstandard: "Past",
	},
	wooloo: {
		isNonstandard: "Past",
	},
	dubwool: {
		isNonstandard: "Past",
	},
	chewtle: {
		isNonstandard: "Past",
	},
	drednaw: {
		isNonstandard: "Past",
	},
	drednawgmax: {
		isNonstandard: "Past",
	},
	yamper: {
		isNonstandard: "Past",
	},
	boltund: {
		isNonstandard: "Past",
	},
	rolycoly: {
		isNonstandard: "Past",
	},
	carkol: {
		isNonstandard: "Past",
	},
	coalossal: {
		isNonstandard: "Past",
	},
	coalossalgmax: {
		isNonstandard: "Past",
	},
	applin: {
		isNonstandard: "Past",
	},
	flapple: {
		isNonstandard: "Past",
	},
	flapplegmax: {
		isNonstandard: "Past",
	},
	appletun: {
		isNonstandard: "Past",
	},
	appletungmax: {
		isNonstandard: "Past",
	},
	silicobra: {
		isNonstandard: "Past",
	},
	sandaconda: {
		isNonstandard: "Past",
	},
	sandacondagmax: {
		isNonstandard: "Past",
	},
	cramorant: {
		isNonstandard: "Past",
	},
	cramorantgulping: {
		isNonstandard: "Past",
	},
	cramorantgorging: {
		isNonstandard: "Past",
	},
	arrokuda: {
		isNonstandard: "Past",
	},
	barraskewda: {
		isNonstandard: "Past",
	},
	toxel: {
		isNonstandard: "Past",
	},
	toxtricity: {
		isNonstandard: "Past",
	},
	toxtricitylowkey: {
		isNonstandard: "Past",
	},
	toxtricitygmax: {
		isNonstandard: "Past",
	},
	toxtricitylowkeygmax: {
		isNonstandard: "Past",
	},
	sizzlipede: {
		isNonstandard: "Past",
	},
	centiskorch: {
		isNonstandard: "Past",
	},
	centiskorchgmax: {
		isNonstandard: "Past",
	},
	clobbopus: {
		isNonstandard: "Past",
	},
	grapploct: {
		isNonstandard: "Past",
	},
	sinistea: {
		isNonstandard: "Past",
	},
	sinisteaantique: {
		isNonstandard: "Past",
	},
	polteageist: {
		isNonstandard: "Past",
	},
	polteageistantique: {
		isNonstandard: "Past",
	},
	hatenna: {
		isNonstandard: "Past",
	},
	hattrem: {
		isNonstandard: "Past",
	},
	hatterene: {
		isNonstandard: "Past",
	},
	hatterenegmax: {
		isNonstandard: "Past",
	},
	impidimp: {
		isNonstandard: "Past",
	},
	morgrem: {
		isNonstandard: "Past",
	},
	grimmsnarl: {
		isNonstandard: "Past",
	},
	grimmsnarlgmax: {
		isNonstandard: "Past",
	},
	obstagoon: {
		isNonstandard: "Past",
	},
	perrserker: {
		isNonstandard: "Past",
	},
	cursola: {
		isNonstandard: "Past",
	},
	sirfetchd: {
		isNonstandard: "Past",
	},
	mrrime: {
		isNonstandard: "Past",
	},
	runerigus: {
		isNonstandard: "Past",
	},
	milcery: {
		isNonstandard: "Past",
	},
	alcremie: {
		isNonstandard: "Past",
	},
	alcremiegmax: {
		isNonstandard: "Past",
	},
	falinks: {
		isNonstandard: "Past",
	},
	pincurchin: {
		isNonstandard: "Past",
	},
	snom: {
		isNonstandard: "Past",
	},
	frosmoth: {
		isNonstandard: "Past",
	},
	stonjourner: {
		isNonstandard: "Past",
	},
	eiscue: {
		isNonstandard: "Past",
	},
	eiscuenoice: {
		isNonstandard: "Past",
	},
	indeedee: {
		isNonstandard: "Past",
	},
	indeedeef: {
		isNonstandard: "Past",
	},
	morpeko: {
		isNonstandard: "Past",
	},
	morpekohangry: {
		isNonstandard: "Past",
	},
	cufant: {
		isNonstandard: "Past",
	},
	copperajah: {
		isNonstandard: "Past",
	},
	copperajahgmax: {
		isNonstandard: "Past",
	},
	dracozolt: {
		isNonstandard: "Past",
	},
	arctozolt: {
		isNonstandard: "Past",
	},
	dracovish: {
		isNonstandard: "Past",
	},
	arctovish: {
		isNonstandard: "Past",
	},
	duraludon: {
		isNonstandard: "Past",
	},
	duraludongmax: {
		isNonstandard: "Past",
	},
	dreepy: {
		isNonstandard: "Past",
	},
	drakloak: {
		isNonstandard: "Past",
	},
	dragapult: {
		isNonstandard: "Past",
	},
	zacian: {
		isNonstandard: "Past",
	},
	zaciancrowned: {
		isNonstandard: "Past",
	},
	zamazenta: {
		isNonstandard: "Past",
	},
	zamazentacrowned: {
		isNonstandard: "Past",
	},
	eternatus: {
		isNonstandard: "Past",
	},
	kubfu: {
		isNonstandard: "Past",
	},
	urshifu: {
		isNonstandard: "Past",
	},
	urshifurapidstrike: {
		isNonstandard: "Past",
	},
	urshifugmax: {
		isNonstandard: "Past",
	},
	urshifurapidstrikegmax: {
		isNonstandard: "Past",
	},
	zarude: {
		isNonstandard: "Past",
	},
	zarudedada: {
		isNonstandard: "Past",
	},
	regieleki: {
		isNonstandard: "Past",
	},
	regidrago: {
		isNonstandard: "Past",
	},
	glastrier: {
		isNonstandard: "Past",
	},
	spectrier: {
		isNonstandard: "Past",
	},
	calyrex: {
		isNonstandard: "Past",
	},
	calyrexice: {
		isNonstandard: "Past",
	},
	calyrexshadow: {
		isNonstandard: "Past",
	},
	wyrdeer: {
		isNonstandard: null,
	},
	kleavor: {
		isNonstandard: null,
	},
	ursaluna: {
		isNonstandard: null,
	},
	basculegion: {
		isNonstandard: null,
	},
	basculegionf: {
		isNonstandard: null,
	},
	sneasler: {
		isNonstandard: null,
	},
	overqwil: {
		isNonstandard: null,
	},
	enamorus: {
		isNonstandard: null,
	},
	enamorustherian: {
		isNonstandard: null,
	},
};
